import { render } from "./IndexChart.vue?vue&type=template&id=5d8f94d0"
import script from "./IndexChart.vue?vue&type=script&lang=js"
export * from "./IndexChart.vue?vue&type=script&lang=js"

import "./IndexChart.vue?vue&type=style&index=0&id=5d8f94d0&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__